//#region src/schema/localization/locales/es.ts
var e = {
	schema: {
		noAllowedValues: "Ningún valor satisface esta restricción enum.",
		example: "Ejemplo",
		examples: "Ejemplos",
		default: "Predeterminado",
		schema: "Esquema",
		emptyObject: "Objeto vacío",
		showAdditionalProperties: "Mostrar propiedades adicionales",
		showOneMoreProperty: "Mostrar 1 propiedad más",
		showMoreProperties: "Mostrar {count} propiedades más",
		forName: "para {name}",
		showSchemaDetails: "Mostrar detalles del esquema",
		oneOf: "Uno de",
		anyOf: "Cualquiera de",
		allOf: "Todos de",
		not: "No",
		unknownType: "tipo desconocido",
		propertyCount: "Propiedades: {count}",
		headerCount: "Encabezados: {count}",
		recursiveReference: "Referencia recursiva a {name}",
		recursive: "recursivo",
		additionalProperties: "propiedades adicionales",
		const: "constante",
		deprecated: "obsoleto",
		discriminator: "Discriminador",
		enum: "enum",
		format: "Formato",
		greaterThan: "mayor que",
		keys: "claves",
		lessThan: "menor que",
		max: "máx.",
		min: "mín.",
		maxLength: "longitud máx.",
		minLength: "longitud mín.",
		multipleOf: "múltiplo de",
		nullable: "admite null",
		propertyNames: "nombres de propiedades",
		pattern: "Patrón",
		copyPattern: "Copiar patrón",
		readOnly: "solo lectura",
		required: "obligatorio",
		hideValues: "Ocultar valores",
		showAllValues: "Mostrar todos los valores",
		type: "Tipo",
		unique: "único",
		values: "valores",
		writeOnly: "solo escritura"
	},
	common: {
		copyDefault: "Copiar valor por defecto",
		copyExample: "Copiar valor de ejemplo"
	},
	actions: { copyLinkTo: "Copiar enlace a {name}" }
};
//#endregion
export { e as es };

//# sourceMappingURL=es.js.map